
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 18a2 2 0 11-4 0 2 2 0 014 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 14c-1.383 0-2.634.56-3.54 1.469a1 1 0 01-1.416-1.412A6.981 6.981 0 0112 12c1.936 0 3.69.787 4.956 2.057a1 1 0 01-1.416 1.412A4.981 4.981 0 0012 14z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 10a8.969 8.969 0 00-6.36 2.632 1 1 0 01-1.413-1.415A10.969 10.969 0 0112 8c3.035 0 5.784 1.23 7.773 3.216a1 1 0 11-1.413 1.416A8.969 8.969 0 0012 10z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 6C8.41 6 5.16 7.454 2.807 9.808a1 1 0 01-1.415-1.414A14.956 14.956 0 0112 4c4.142 0 7.894 1.68 10.608 4.394a1 1 0 01-1.415 1.414A12.956 12.956 0 0012 6z"}})])
          )
        }
      }
    